import isNumber from './is-number';
var isEven = function (num) {
    return isNumber(num) && num % 2 === 0;
};
export default isEven;
//# sourceMappingURL=is-even.js.map